import { createStore } from "redux"
import root from "./main"

const store = createStore(root)
export default store
